"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extract = void 0;
const extract = function (className, cssInJs) {
  let defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    className,
    cssInJs,
    defaultProps
  };
};
exports.extract = extract;